import { DataAPIService } from './AxiosAPIService';
import {
  Note,
  PatchNoteRequest,
  PostNoteRequest,
  NotesResponse,
  DeleteNoteRequest,
} from '../types/Notes';
import { logger } from './SharedService';

export const NoteTitles: any = {
  alerts: 'Note on an accident',
  devices: 'Note on a device',
  drivers: 'Note on a driver',
  trips: 'Note on a trip',
  vehicles: 'Note on a vehicle',
  videos: 'Note on a video',
};

export const getNotes = async (fleetId: string, entityName: string, entityId: string, query: string): Promise<NotesResponse> => {
  logger.info('GET', 'REQUEST', 'getNotes', `/${fleetId}/notes/${entityName}/${entityId}${query}`);

  const { data } = await DataAPIService.api.get<NotesResponse>(`/${fleetId}/notes/${entityName}/${entityId}${query}`);

  logger.info('GET', 'RESPONSE', 'getNotes', data);
  return data;
};

export const getNotesByQuery = async (fleetId: string, query: string): Promise<NotesResponse> => {
  logger.info('GET', 'REQUEST', 'getNotes', `/${fleetId}/notes${query}`);

  const { data } = await DataAPIService.api.get<NotesResponse>(`/${fleetId}/notes${query}`);

  logger.info('GET', 'RESPONSE', 'getNotes', data);
  return data;
};

export const postNote = async (payload: PostNoteRequest): Promise<Note> => {
  const {
    fleetId, entityName, entityId, text, title, isAutoGenerated,
  } = payload;

  logger.info('POST', 'REQUEST', 'postNote', `/${fleetId}/notes/${entityName}/${entityId}`, payload);

  const { data } = await DataAPIService.api.post<Note>(`/${fleetId}/notes/${entityName}/${entityId}`, {
    title: (title && title !== '') ? title : NoteTitles[entityName],
    text,
    isAutoGenerated,
  })
    .catch((e) => Promise.reject(e.response.data));
  logger.info('POST', 'RESPONSE', 'postNote', data);
  return data;
};

export const patchNote = async (payload: PatchNoteRequest): Promise<Note> => {
  const {
    id, fleetId, entityName, title, text,
  } = payload;

  logger.info('PATCH', 'REQUEST', 'patchNote', `/${fleetId}/notes/${id}`, payload);

  const { data } = await DataAPIService.api.patch<Note>(`/${fleetId}/notes/${id}`, {
    title: (title && title !== '') ? title : NoteTitles[entityName],
    text,
  })
    .catch((e) => Promise.reject(e.response.data));
  logger.info('PATCH', 'RESPONSE', 'patchNote', data);
  return data;
};

export const deleteNote = async (payload: DeleteNoteRequest): Promise<Note> => {
  const { fleetId, id } = payload;

  logger.info('DELETE', 'REQUEST', 'deleteNote', `/${fleetId}/notes/${id}`, payload);

  const { data } = await DataAPIService.api.delete<Note>(`/${fleetId}/notes/${id}`);

  logger.info('DELETE', 'RESPONSE', 'deleteNote', data);

  return data;
};
